import {z} from 'zod';

import {UseHookType} from '../../api-hook/api-hook-type';

import {
    DashboardPostponeRecommendationPayloadApiType,
    DashboardPostponeRecommendationResponseApiType,
} from './dashboard-recommendations-api-type';

export enum DashboardRecommendationTypeEnum {
    check = 'check',
    review = 'review',
    gallery = 'gallery',
    description = 'description',
    category = 'category',
    needAction = 'need_action',

    socialLinks = 'social_links',
    messengers = 'messengers',
    peculiarities = 'catalog_features',
    yandexCompetitorReviewsCount = 'yandex_competitor_reviews_count',
    yandexGoodPlace = 'yandex_good_place',

    yandexNavigationStories = 'yandex_navigation_stories',
    yandexStories = 'yandex_stories',

    logo = 'logo',
    cover = 'cover',

    yandexPosts = 'posts_yandex',
    googlePosts = 'posts_google',
    products = 'product_group',
}

export const dashboardRecommendationItem = z.object({
    key: z.nativeEnum(DashboardRecommendationTypeEnum),
    count: z.number(),
    postponed: z.number().nullable(),
    hasAnyOlderPost: z.boolean().optional(),
    filterKey: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    lpsPoints: z.number().nullable().optional(),
});

export type DashboardRecommendationResponseItemType = z.infer<typeof dashboardRecommendationItem>;

export type DashboardRecommendationItemType = Omit<DashboardRecommendationResponseItemType, 'key'> & {
    key: DashboardRecommendationTypeEnum;
};

export type DashboardRecommendationsHookType = UseHookType<Array<DashboardRecommendationResponseItemType>> & {
    onPostponeChange: (recommendationKey: DashboardRecommendationTypeEnum, postpone: number | null) => void;
};

export type DashboardRecommendationHookType = {
    isInProgress: boolean;
    postponeRecommendation: (
        recommendationKey: DashboardRecommendationTypeEnum,
        payload: DashboardPostponeRecommendationPayloadApiType
    ) => Promise<DashboardPostponeRecommendationResponseApiType>;
    cancelRecommendationPostpone: (recommendationKey: DashboardRecommendationTypeEnum) => Promise<void>;
};
